import React, { useEffect } from 'react';
import { ProviderParams } from '../models/react';
import { EngagementContextType, EngagementStatus, engagementStatusDefault } from '../models/engagement';
import { SDKEngagement, SDKEngagementStatus } from '../models/sdk';
import useSessionStorage from '../hooks/sessionStorage.hook';

const EngagementContext = React.createContext<EngagementContextType | undefined>(undefined);
export function useEngagementContext() {
    return React.useContext(EngagementContext);
}

export default function EngagementProvider({ children }: ProviderParams) {
    const engagementStorage = useSessionStorage("engagement");
    const engagementStatusStorage = useSessionStorage("engagementStatus");
    const [engagement, setEngagement] = React.useState<SDKEngagement | undefined>(retrieveEngagement());
    const [engagementStatus, setEngagementStatus] = React.useState<EngagementStatus>(retrieveEngagementStatus(true))

    function retrieveEngagement(): SDKEngagement | undefined {
        let engagementOldSession: SDKEngagement | undefined = undefined;
        try {
            const engagementOldSessionStr = engagementStorage.value
            if (engagementOldSessionStr) {
                engagementOldSession = JSON.parse(engagementOldSessionStr);
            }
        } catch (error) {
            console.error("Error retrieving engagement from session storage:", error);
        }
        return engagementOldSession;
    }

    function retrieveEngagementStatus(init: boolean = false): EngagementStatus {
        let engagementStatusOldSession: EngagementStatus = engagementStatusDefault;
        try {
            const engagementStatusOldSessionStr = engagementStatusStorage.value
            if (engagementStatusOldSessionStr) {
                engagementStatusOldSession = JSON.parse(engagementStatusOldSessionStr);
            }
        } catch (error) {
            console.error("Error retrieving engagement status from session storage:", error);
        }

        if (engagement && engagement.engagementStatus != SDKEngagementStatus.TERMINATED && !engagement.getMessages) {
            engagementStatusOldSession.retrieved = true;
        }
        return engagementStatusOldSession;
    }
    useEffect(() => {
        const engagementNewSession = retrieveEngagement();
        const engagementOldStatus = retrieveEngagementStatus(false)
        if (Object.keys(engagementNewSession || {}).length >0) {
            setEngagement(engagementNewSession);
            setEngagementStatus({closed: engagementOldStatus?.closed || false, retrieved: true, history:engagementOldStatus?.history})
        }else{ 
            setEngagement(undefined)
            setEngagementStatus({closed: engagementOldStatus?.closed || false, retrieved: false, history:engagementOldStatus?.history})
        }
    },[])

    function resetEngagement() {
        setEngagement(undefined)
        engagementStorage.removeValue()
    }

    function closeEngagement() {

        setEngagementStatus(engagementStatusDefault)
    }

    function isConnected():boolean {
        if (engagement && engagement.sendMessage !== undefined) return true
        return false
    }
    function isHistory():boolean {
        return engagementStatus.history && !engagementStatus.closed
        // return (engagement && engagement.engagementStatus === SDKEngagementStatus.TERMINATED) || false
    }
    function initEngagement() {
        setEngagementStatus({retrieved:false, closed: false, history:false})
    }
    function activateHistoryMode() {
        setEngagementStatus({...engagementStatus, history:true})
}
    
    function isActive():boolean {
        return !!engagement  
    }

    useEffect(() => {
        if (engagement) {
            const engagementStr = JSON.stringify(engagement);
            try  {
                engagementStorage.setValue(engagementStr);
            } catch (error) {
                console.error("Error storing engagement at session storage:", error);
            }
         }
    }, [engagement, engagement?.engagementStatus])
    

    
    useEffect(() => {
        if (engagementStatus) {
            const engagementStatusStr = JSON.stringify(engagementStatus)
            try  {
                engagementStatusStorage.setValue(engagementStatusStr);
            } catch (error) {
                console.error("Error storing engagement status at session storage:", error);
            }
         }
    }, [engagementStatus])

    
    return (
        <EngagementContext.Provider value={{ engagement, setEngagement, isActive, isHistory, closeEngagement, initEngagement, activateHistoryMode, resetEngagement, engagementStatus, setEngagementStatus, isConnected }}>
            {children}
        </EngagementContext.Provider>
    );
}